import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { registerServiceWorker, initConnectivityListener } from "./pwa";
import Screenloader from "commons/components/ScreenLoader";
import {
  adoptSessionFromOpenTabs,
  startSessionHost,
} from "./config/sessionSync";

const container = document.getElementById("root");
const root = createRoot(container);

// A tab opened with Cmd/Ctrl+click, middle click or "Open Link in New Tab"
// starts with an empty sessionStorage, where this app keeps its auth. Adopt the
// session from an already open tab before rendering, otherwise ProtectedRoute
// would immediately bounce the new tab to /login.
// Resolves instantly when the tab already has a session or the URL is public.
const sessionHandoff = adoptSessionFromOpenTabs();

// Only show the loader for the tabs that actually wait for a hand-off.
let rendered = false;
const loaderTimer = setTimeout(() => {
  if (!rendered) root.render(<Screenloader />);
}, 60);

sessionHandoff.finally(() => {
  clearTimeout(loaderTimer);
  rendered = true;
  startSessionHost();
  root.render(<App />);
});

// Register PWA service worker & connectivity listener
registerServiceWorker();
initConnectivityListener();
